// @ts-nocheck
import { dapiFetchCache, dapiFetch, IDapiRequest } from '@origin-digital/daxi';

import {
  IArticleDataResponse,
  ICategoriesDataResponse,
  ICategoryWithArticlesDataResponse,
} from '../models';

/*
 * This code has been generated from an OpenAPI spec.
 */

export interface IGetArticleRequest {
  slug: string;
}

/**

 */
export const getArticle = async (baseUrl: string, data: IGetArticleRequest, authorization?: IDapiRequest["authorization"], ttlInMin: number = 0): Promise<IArticleDataResponse> => {
    try {
        const method = 'GET';
        const url = baseUrl + getArticleUrl(data);
        const queryString = '';

        if (ttlInMin > 0) {
          const fetchOptions = { method, authorization, ttlInMin };
          const response = await dapiFetchCache<IArticleDataResponse>(url + queryString, fetchOptions);
          return response.data as IArticleDataResponse;
        }

        const fetchOptions = { method, authorization };
        const response = await dapiFetch<IArticleDataResponse>(url + queryString, fetchOptions);
        return response.data as IArticleDataResponse;
    } catch (error) {
        error.newRelic = `'GET: ${ getArticleUrl(data) }'`;
        throw error;
    }
};

/**
  * Generate a getter for the getArticle endpoint url that substitutes in given url params.
  */
const getArticleUrl = (data: IGetArticleRequest) => {
    return '/api/support/articles/{slug}'.replace('{' + 'slug' + '}', encodeURIComponent(data.slug));
};


export interface IGetCategoriesRequest {
}

/**

 */
export const getCategories = async (baseUrl: string,  authorization?: IDapiRequest["authorization"], ttlInMin: number = 0): Promise<ICategoriesDataResponse> => {
    try {
        const method = 'GET';
        const url = baseUrl + getCategoriesUrl();
        const queryString = '';

        if (ttlInMin > 0) {
          const fetchOptions = { method, authorization, ttlInMin };
          const response = await dapiFetchCache<ICategoriesDataResponse>(url + queryString, fetchOptions);
          return response.data as ICategoriesDataResponse;
        }

        const fetchOptions = { method, authorization };
        const response = await dapiFetch<ICategoriesDataResponse>(url + queryString, fetchOptions);
        return response.data as ICategoriesDataResponse;
    } catch (error) {
        error.newRelic = `'GET: ${ getCategoriesUrl() }'`;
        throw error;
    }
};

/**
  * Generate a getter for the getCategories endpoint url that substitutes in given url params.
  */
const getCategoriesUrl = () => {
    return '/api/support/categories';
};


export interface IGetCategoryArticlesRequest {
  id: string;
}

/**

 */
export const getCategoryArticles = async (baseUrl: string, data: IGetCategoryArticlesRequest, authorization?: IDapiRequest["authorization"], ttlInMin: number = 0): Promise<ICategoryWithArticlesDataResponse> => {
    try {
        const method = 'GET';
        const url = baseUrl + getCategoryArticlesUrl(data);
        const queryString = '';

        if (ttlInMin > 0) {
          const fetchOptions = { method, authorization, ttlInMin };
          const response = await dapiFetchCache<ICategoryWithArticlesDataResponse>(url + queryString, fetchOptions);
          return response.data as ICategoryWithArticlesDataResponse;
        }

        const fetchOptions = { method, authorization };
        const response = await dapiFetch<ICategoryWithArticlesDataResponse>(url + queryString, fetchOptions);
        return response.data as ICategoryWithArticlesDataResponse;
    } catch (error) {
        error.newRelic = `'GET: ${ getCategoryArticlesUrl(data) }'`;
        throw error;
    }
};

/**
  * Generate a getter for the getCategoryArticles endpoint url that substitutes in given url params.
  */
const getCategoryArticlesUrl = (data: IGetCategoryArticlesRequest) => {
    return '/api/support/category/{id}'.replace('{' + 'id' + '}', encodeURIComponent(data.id));
};

